export default __webpack_public_path__ + "static/smp-spec-34be9271835d900eb4b49311e7fe92e9.png";